var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-cropper",on:{"wheel":_vm.handlerScroll}},[_c('img',{ref:"img",staticStyle:{"width":"100%","height":"100%","object-fit":"cover"},attrs:{"src":_vm.src,"alt":"img"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }